module.exports = __webpack_public_path__ + "cb55104b6ebec1e5e7ce1be3f65c81c0.MP3";